import { useState } from 'react'

import toast from '../components/toast'
import { openSignedUrl } from '../utils/openSignedUrl'
import { certificateErrorMessage } from '../utils/calibrationCertificate'

/**
 * US-40351 — click behaviour shared by every "Calibration Certificate" row
 * (invoice vehicle attachments, ADAS Report documentation).
 *
 * `fetchUrl` is the service call that renders the PDF and resolves to its URL.
 * openSignedUrl must run synchronously inside the click: Safari blocks a
 * window.open made once the click's turn has passed (AB#39901), and a
 * react-query mutationFn only starts after a promise chain, so this hook does
 * not go through useMutation. The 409 { reason } the API sends when the
 * document is no longer eligible is what the error toast shows.
 *
 * @param {Function} fetchUrl  () => Promise<string>
 * @returns {{ openCertificate: Function, isLoading: Boolean }}
 */
const useOpenCertificate = fetchUrl => {
  const [isLoading, setIsLoading] = useState(false)

  const openCertificate = () => {
    setIsLoading(true)
    openSignedUrl(fetchUrl)
      .catch(err => toast.error({
        title: 'Certificate errors',
        body: certificateErrorMessage(err, 'Could not open the calibration certificate.'),
      }))
      .finally(() => setIsLoading(false))
  }

  return { openCertificate, isLoading }
}

export default useOpenCertificate
